import { Grid } from "@mui/material";
import * as React from "react";
import {
  Create,
  ReferenceInput,
  SelectInput,
  TextInput,
  required,
  NumberInput,
} from "react-admin";
import { StatusEnum, ProductTypeEnum, ProductVisibilityEnum } from "src/common/enum";
import { ProductCreateComponent } from "./ProductComponent";
import { FormTab, TabbedForm } from "src/enterprise/ra-rbac";
import { TinyMCEContentInput } from '../../components/input';

export const ProductCreate = () => {
  return (
    <Create component={ProductCreateComponent}>
      <TabbedForm>
        <FormTab label="General" name="general">
          <Grid container rowSpacing={1} columnSpacing={2}>
            <Grid container item rowSpacing={1} columnSpacing={2}>
              <Grid item sm={12} lg={6}>
                <TextInput source="legacy_id"/>
              </Grid>
              <Grid item sm={12} md={6}>
                <ReferenceInput
                  source="attributeSet"
                  reference="admin/product/attribute-sets"
                  validate={required()}
                >
                  <SelectInput
                    optionText={(record) => {
                      return record.name;
                    }}
                    label="Atribute Set"
                    source="id"
                    validate={required()}
                  />
                </ReferenceInput>
              </Grid>
            </Grid>
            <Grid container item sm={12} md={6} rowSpacing={1} columnSpacing={2}>
              <Grid item sm={12}>
                <TextInput source="name" validate={required()}/>
              </Grid>
              <Grid item sm={12}> 
                <TinyMCEContentInput source="description" required fullWidth validate={required()}/>
              </Grid>
              <Grid item sm={12}> 
                <TinyMCEContentInput source="shortDescription" required fullWidth validate={required()}/>
              </Grid>   
            </Grid>
            <Grid container item sm={12} md={6} rowSpacing={1} columnSpacing={2}>
                <Grid item sm={12}>
                  <SelectInput source="visibility" choices={ProductVisibilityEnum} validate={required()} />
                </Grid>
                <Grid item sm={12}>
                  <TextInput source="sku" validate={required()} />
                </Grid>
                <Grid item sm={12}>
                  <SelectInput source="type" choices={ProductTypeEnum} validate={required()} />
                </Grid>
                <Grid item sm={12}>
                  <NumberInput source="weight" min={0} validate={required()} />
                </Grid>
                <Grid item sm={12}>
                  <SelectInput source="status" choices={StatusEnum} validate={required()} />
                </Grid>
            </Grid>
          </Grid>
        </FormTab>
        <FormTab label="SEO" name="seo">
          <Grid container item sm={12} md={6} rowSpacing={1} columnSpacing={2}>
            <Grid item sm={12}>
              <TextInput source="metaTitle"/>
            </Grid>
            <Grid item sm={12}>
              <TextInput
                source="metaDescription"
                rows={4}
                fullWidth
                multiline
              />
            </Grid>
            <Grid item sm={12}>
              <TextInput source="metaKeywords"  multiline rows={4}/>
            </Grid>
          </Grid>
        </FormTab>
      </TabbedForm>
    </Create>
  );
};
